import { types } from 'mobx-state-tree'

export const UserTag = types.model('UserTag').props({
  id: types.number,
  is_locked: types.maybeNull(types.boolean),
  key: types.string,
  value: types.string,
})
